import { timelineEvents } from "@/mocks/home";

export default function Timeline() {
  return (
    <section id="timeline" className="w-full bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <div className="mb-8 max-w-3xl">
          <span className="flex items-center gap-2 text-xs font-medium uppercase tracking-[0.24em] text-primary-600">
            <i className="ri-timeline-view text-sm" />
            Timeline
          </span>
          <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
            深度整理时间线
          </h2>
          <p className="mt-2 text-sm leading-7 text-foreground-600">
            以下以编号 A-2043 为例，把关键节点按时间归并。每个节点都标注了它对应的话题分区，便于回到证据汇总区核对原始出处。
          </p>
        </div>

        <div className="relative">
          <span className="timeline-line absolute left-4 top-0 hidden h-full w-px md:left-1/2 md:block md:-translate-x-1/2" />
          <span className="timeline-line absolute left-4 top-0 h-full w-px md:hidden" />

          <ol className="space-y-6 md:space-y-0">
            {timelineEvents.map((event, index) => {
              const isLeft = index % 2 === 0;
              return (
                <li
                  key={event.date}
                  className={`relative pl-12 md:flex md:pl-0 ${
                    isLeft ? "md:justify-start" : "md:justify-end"
                  }`}
                >
                  <span className="absolute left-4 top-2 z-10 flex h-3.5 w-3.5 -translate-x-1/2 items-center justify-center rounded-full bg-accent-500 ring-4 ring-background-50 md:left-1/2">
                    <span className="h-1.5 w-1.5 rounded-full bg-accent-950/40" />
                  </span>

                  <div
                    className={`w-full rounded-lg border border-background-200 bg-background-100 p-4 md:my-4 md:w-[46%] md:p-5 ${
                      isLeft ? "md:mr-auto" : "md:ml-auto"
                    }`}
                  >
                    <div className="flex flex-wrap items-center gap-2">
                      <span className="rounded-md bg-primary-500 px-2 py-0.5 font-label text-[11px] font-semibold text-background-50">
                        {event.tag}
                      </span>
                      <span className="text-xs text-foreground-500">{event.date}</span>
                    </div>
                    <h3 className="mt-2.5 font-heading text-base font-bold text-foreground-950">
                      {event.title}
                    </h3>
                    <p className="mt-1.5 text-sm leading-6 text-foreground-600">{event.desc}</p>
                  </div>
                </li>
              );
            })}
          </ol>
        </div>

        <div className="mt-8 flex flex-wrap items-center justify-between gap-3 rounded-lg border border-background-200 bg-background-100 px-5 py-4">
          <p className="flex items-center gap-2 text-sm text-foreground-600">
            <i className="ri-node-tree text-base text-primary-600" />
            本条时间线共 <strong className="font-semibold text-foreground-950">14</strong> 个节点，
            其中 6 个已完成交叉核对
          </p>
          <a
            href="#timeline"
            className="flex items-center gap-1 whitespace-nowrap rounded-md border border-primary-300 px-3.5 py-2 text-sm text-primary-700 transition-colors hover:bg-primary-50"
          >
            展开完整时间线
            <i className="ri-arrow-down-s-line text-base" />
          </a>
        </div>
      </div>
    </section>
  );
}